<template>
  <div>
    <a
      aria-expanded="false"
      aria-haspopup="true"
      class="nounderline"
      :data-target="`#${id}`"
      data-toggle="dropdown"
      href="#"
      role="button"
      @click="$emit('click', $event)"
    >
      <div>
        <slot />
      </div>
    </a>
    <div :id="id" class="dropdown-menu" :class="{ show: show }">
      <slot name="drop" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Droppable',
  props: {
    id: {
      type: String,
      default: () => Math.random().toString(36),
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style scoped>
.dropdown-menu {
  background-color: transparent;
  border: none;
}
a:hover {
  text-decoration: none !important;
}
</style>
